import * as actionType from './actionTypes';

export function setAdminState(state: string) {
  return {
    type: actionType.SET_ADMIN_STATE,
    payload: state,
  }
}

export function setOrganisations(organisations:[]) {
  return {
    type: actionType.SET_SITES,
    payload: organisations,
  }
}

export function setUser(user:{}) {
  return {
    type: actionType.SET_USER,
    payload: user,
  }
}

export function setUsers(users:[]) {
  return {
    type: actionType.SET_USERS,
    payload: users,
  }
}
